<template>
  <div class="bom-validation-toggle-version flex">
    <h6 class="bom-validation-toggle-version__title-text">
      {{ toggleModelValue ?
        'You are seeing a new version of the results layout.'
        : 'There is a new version for you to check the results.'
      }}
    </h6>
    <div class="bom-validation-toggle-version__toggle">
      <span class="bom-validation-toggle-version__toggle-title">
        {{ toggleModelValue? 'Back to older version' : 'View the new version' }}
      </span>
      <mi-switch
        v-model="toggleModelValue"
        color="primary"
        @click="saveLastVersionPreference"
      >
      </mi-switch>
    </div>
  </div>
</template>

<script>
  import { inject } from 'vue'
  import { LocalStorage } from 'quasar'
  import MiSwitch from '../../../../../packages/@mi-library/MiSwitch/MiSwitch.vue'
  import { BOM_VALIDATION_ERROR_TYPES_METRICS, SHOW_NEW_VERSION_PROVIDER } from '../../../../../constants'
  import { BOM_VALIDATIONS_VERSION_TOGGLE } from '../../../../../utils/analytics/constants/validations/constants'
  import recordAnalytics from '../../../../../utils/analytics/recordAnalytics'

  export default {
    name: 'BomValidationVersionToggle',
    components: { MiSwitch },
    props: {
      resultType: {
        type: String,
        required: false,
        default: ''
      },
      validationId: {
        type: String,
        required: false,
        default: ''
      }
    },
    emits: ['switch-current-version'],
    setup(props) {
      const toggleModelValue = inject(SHOW_NEW_VERSION_PROVIDER)

      const saveLastVersionPreference = () => {
        LocalStorage.set(process.env.VUE_APP_STORAGE_KEY_VALIDATIONS_NEW_VERSION, toggleModelValue.value)

        recordAnalytics({
          name: BOM_VALIDATIONS_VERSION_TOGGLE,
          attributes: {
            toggleOn: toggleModelValue.value.toString(),
            validationId: props.validationId,
            resultType: BOM_VALIDATION_ERROR_TYPES_METRICS[props.resultType]
          }
        })
      }

      return {
        toggleModelValue,
        saveLastVersionPreference
      }
    }
  }
</script>

<style lang="scss" scoped>
  .bom-validation-toggle-version {
    background-color: #bfddf1;
    width: 100%;
    margin: 0 0 4px;
    padding: 16px 12px;
    justify-content: space-between;

    &__title-text {
      font-size: 16px;
      margin: 0;
      color: #244b84;
    }

    &__toggle-title {
      font-size: 14px;
      color: #244b84;
      margin-right: 8px;
    }
  }
</style>
